import { LogLevel, MetricUnit, TMPL_LOG_LISTENER_EVENT, } from '@amzn/aws-marketing-experience-builder-template-types';
import { isServer } from '../environment/is-server';
export const getLogger = (options) => {
    const { namespace, orgId } = options;
    const getPayload = (originalPayload) => {
        return typeof originalPayload === 'string' ? { message: originalPayload } : originalPayload;
    };
    const logEvent = (logLevel, metricName, originalPayload) => {
        if (isServer()) {
            return;
        }
        const payload = getPayload(originalPayload);
        document.dispatchEvent(new CustomEvent(TMPL_LOG_LISTENER_EVENT, {
            detail: {
                logLevel,
                namespace,
                orgId,
                metricName,
                payload,
            },
        }));
    };
    const startPerformanceMetric = (metricName) => {
        const startTime = Date.now();
        return {
            logPerformanceMetric: (originalPayload) => {
                const payload = {
                    ...getPayload(originalPayload),
                    value: Math.floor(Date.now() - startTime),
                    unit: MetricUnit.MILLISECONDS,
                };
                logEvent(LogLevel.INFO, metricName, payload);
            },
        };
    };
    return {
        debug: logEvent.bind(null, LogLevel.DEBUG),
        info: logEvent.bind(null, LogLevel.INFO),
        warn: logEvent.bind(null, LogLevel.WARN),
        error: logEvent.bind(null, LogLevel.ERROR),
        startPerformanceMetric,
    };
};
